import { createFileRoute } from "@tanstack/react-router"
import { KnowledgeBasePage } from "@/rag"

export const Route = createFileRoute(
  "/(user)/t/$tenantSlug/knowledge-bases/$id",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()

  return <KnowledgeBasePage id={id} />
}
